import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const SubmittedByDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 8px;
`

export const ActionIcons = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
`

export const divider = css`
  margin: 5px 0;
`

export const icon = css`
  margin-right: 4px;
  cursor: pointer;
`

export const flexColumn = css`
  flex-direction: column;
`
